var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "html-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.007A5.004 5.004 0 0 1 7.007 2h33.986A5.004 5.004 0 0 1 46 7.007v33.986A5.004 5.004 0 0 1 40.993 46H7.007A5.004 5.004 0 0 1 2 40.993V7.007zm4 0v33.986C6 41.551 6.449 42 7.007 42h33.986c.558 0 1.007-.449 1.007-1.007V7.007C42 6.449 41.551 6 40.993 6H7.007C6.449 6 6 6.449 6 7.007zm11.414 12.407L12.828 24l4.586 4.586a2 2 0 0 1-2.828 2.828l-6-6a2 2 0 0 1 0-2.828l6-6a2 2 0 0 1 2.828 2.828zm13.172 9.172L35.172 24l-4.586-4.586a2 2 0 0 1 2.828-2.828l6 6a2 2 0 0 1 0 2.828l-6 6a2 2 0 0 1-2.828-2.828zm-5.424-12.374a2 2 0 0 1 3.676 1.576l-6 14a2 2 0 0 1-3.676-1.576l6-14z",
    fillRule: "nonzero",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml1);
export default __webpack_public_path__ + "static/media/html-1.68a6d08cb1bce52cc991cd95bc7c4c12.svg";
export { ForwardRef as ReactComponent };